// extracted by mini-css-extract-plugin
export default {"container":"RunDetails_container__s-psO","header":"RunDetails_header__HJS2M"};